import React from "react";
import { Input } from "antd";
import classes from "./color-setting-popover.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { selectSettingColors } from "../../../../../reducers/editor/selectors";
import {
  setCurrentObjectColor,
  setDetectedFieldColor,
  setDrawingObjectColor,
} from "../../../../../reducers/editor/actions";
import { SETTING_DEFAULT_COLORS } from "../../../../../constants/editor";
import classNames from "classnames";

const ColorSettingPopover = () => {
  const dispatch = useDispatch();
  const settingColors = useSelector(selectSettingColors);

  const onChangeDrawingObject = (e) => {
    dispatch(setDrawingObjectColor(e.target.value));
  };

  const onChangeCurrentObject = (e) => {
    dispatch(setCurrentObjectColor(e.target.value));
  };

  const onChangeDetectedField = (e) => {
    dispatch(setDetectedFieldColor(e.target.value));
  };

  const onSetDefaultColors = () => {
    dispatch(setDrawingObjectColor(SETTING_DEFAULT_COLORS.DRAWING_OBJECT));
    dispatch(setCurrentObjectColor(SETTING_DEFAULT_COLORS.CURRENT_OBJECT));
    dispatch(setDetectedFieldColor(SETTING_DEFAULT_COLORS.DETECTED_FIELD));
  };

  return (
    <div className={classes.ColorSettingWrap}>
      <div className={classes.ColorSettingItemWrap}>
        <Input
          className={classes.InputItem}
          type="color"
          value={settingColors.drawingObject}
          onChange={onChangeDrawingObject}
        />
        <div className={classes.TitleWrap}>
          <span>Drawing Object</span>
        </div>
      </div>

      <div className={classes.ColorSettingItemWrap}>
        <Input
          className={classes.InputItem}
          type="color"
          value={settingColors.currentObject}
          onChange={onChangeCurrentObject}
        />
        <div className={classes.TitleWrap}>
          <span>Current Object</span>
        </div>
      </div>

      <div className={classes.ColorSettingItemWrap}>
        <Input
          className={classes.InputItem}
          type="color"
          value={settingColors.detectedField}
          onChange={onChangeDetectedField}
        />
        <div className={classes.TitleWrap}>
          <span>Detected Field</span>
        </div>
      </div>

      <div
        className={classNames(classes.UseDefaultColor, "text-primary")}
        onClick={onSetDefaultColors}
      >
        Use default colors
      </div>
    </div>
  );
};

export default ColorSettingPopover;
